import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, Box, Link, Grid, Divider } from '@mui/material';
import './Footer.scss';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box component="footer" className="footer">
            <Container maxWidth="lg">
                {/* <Grid container spacing={4}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h6" color="textPrimary" gutterBottom>
                            PlanetB
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Creating innovative mobile apps for a better digital experience.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h6" color="textPrimary" gutterBottom>
                            Quick Links
                        </Typography>
                        <Link component={RouterLink} to="/" color="textSecondary" display="block" gutterBottom>
                            Home
                        </Link>
                        <Link href="#" color="textSecondary" display="block" gutterBottom>
                            About Us
                        </Link>
                        <Link href="#" color="textSecondary" display="block" gutterBottom>
                            Contact
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h6" color="textPrimary" gutterBottom>
                            Connect
                        </Typography>
                        <Link href="#" color="textSecondary" display="block" gutterBottom>
                            Twitter
                        </Link>
                        <Link href="#" color="textSecondary" display="block" gutterBottom>
                            Facebook
                        </Link>
                        <Link href="#" color="textSecondary" display="block" gutterBottom>
                            Instagram
                        </Link>
                    </Grid>
                </Grid> */}
                {/* <Divider sx={{ my: 3 }} /> */}
                <Box textAlign="center" pt={2} pb={2}>
                    <Typography variant="body2" color="textSecondary">
                        © {currentYear} PlanetB Inc. All rights reserved.
                        {' | '}
                        <Link href="/privacy.html" color="inherit">
                            Privacy Policy
                        </Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;